import { render, staticRenderFns } from "./tableEvals.vue?vue&type=template&id=2b0cf478&"
import script from "./tableEvals.vue?vue&type=script&lang=js&"
export * from "./tableEvals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports